import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async descargarPlantilla(uri, formato = 'base64') {
    let config = {};

    if (formato === 'pdf') {
      config = { responseType: 'blob' };
    }

    return await axiosIns.get(obtenerUrlAPIComisiones(`${uri}?formato=${formato}`), config);
  },
};
